import React, { Fragment } from 'react';

export default function smartTable() {
    const { className, columnConfig, data, rowClick, activeRowOpen, activeRowContent, headerMissing } = this.props;

    return (
        <div className={`smart-table-wrapper ${className || ''}`}>
            {!headerMissing && <ul className="smart-table-header">
                {columnConfig.map((item, index) => <li key={index} className={item.columnClassName || ''}>
                    {item.name && item.name()}
                </li>)}
            </ul>}

            <div className="smart-table-body">
                {data.map((item, index) => {
                    const rowActive = !!activeRowOpen?.(item);

                    return <Fragment key={index}>
                        <ul className={`smart-table-list-item ${rowActive ? 'active' : ''}`} onClick={e => rowClick && rowClick(e, item)}>
                            {columnConfig.map((subItem, subIndex) => <li key={subIndex} className={subItem.rowClassName || ''}>
                                {subItem.row(item, index, rowActive)}
                            </li>)}
                        </ul>

                        {activeRowContent && <div className={`smart-table-list-active-row-content ${rowActive ? 'smart-table-row-open' : ''}`}>
                            {activeRowContent(item)}
                        </div>}
                    </Fragment>;
                })}
            </div>
        </div>
    );
};
